let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3IaOg")).then(() => parcelRequire('1Lf8R'));